(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function ensureOverlayLayer() {
      if (window.themeOverlayLayer) return window.themeOverlayLayer;

      var stack = [];
      var syncState = function () {
        document.documentElement.classList.toggle('overlay-layer-open', stack.length > 0);
      };

      window.themeOverlayLayer = {
        open: function (entry) {
          if (!entry || !entry.id) return;
          this.close(entry.id);
          stack.push(entry);
          syncState();
        },
        close: function (id) {
          var index = stack.findIndex(function (entry) {
            return entry.id === id;
          });
          if (index >= 0) stack.splice(index, 1);
          syncState();
        },
        top: function () {
          return stack[stack.length - 1] || null;
        },
        closeTop: function () {
          var entry = this.top();
          if (entry && typeof entry.close === 'function') entry.close();
        },
      };

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        window.themeOverlayLayer.closeTop();
      });

      return window.themeOverlayLayer;
    }

    var overlayLayer = ensureOverlayLayer();

    // Drawer Manager - 单例模式
    if (window.themeDrawer) return;

    // One same-URL entry guards the mobile overlay stack. A Back closes one layer;
    // button/overlay/Escape closes consume it only after the final drawer closes.
    // Never traverse an entry owned by filters, variants, or another document.
    var drawerHistory = {
      key: '__freshineDrawer',
      sequence: 0,
      session: Date.now().toString(36) + Math.random().toString(36).slice(2),
      entries: new Map(),
      stack: [],
      queued: new Set(),
      current: null,
      pending: null,
      notifyPending: false,
      handling: false,

      entry: function (state) {
        return state && this.entries.get(state[this.key]);
      },

      push: function () {
        var token = this.session + ':' + (++this.sequence);
        var entry = { token: token, url: window.location.href, active: true };
        var state = Object.assign({}, window.history.state);
        state[this.key] = token;
        try {
          window.history.pushState(state, '', entry.url);
        } catch (error) {
          // Embedded/restricted browsers still retain normal drawer controls.
          return;
        }
        this.entries.set(token, entry);
        this.current = entry;
      },

      track: function (id, drawer, wrapper) {
        if (drawer.options.closeOnBack === false || !window.matchMedia('(max-width: 1023px)').matches
          || !/^https?:$/.test(window.location.protocol)) return;
        this.stack.push({ id: id, drawer: drawer, wrapper: wrapper });
        if (!this.current) this.push();
        if (this.removalObserver) return;
        var owner = this;
        this.removalObserver = new MutationObserver(function (records) {
          if (!owner.stack.length || !records.some(function (record) { return record.removedNodes.length; })) return;
          owner.stack.slice().reverse().forEach(function (item) {
            if (!item.wrapper.isConnected) window.themeDrawer.close(item.id);
          });
        });
        this.removalObserver.observe(document.body, { childList: true, subtree: true });
      },

      consume: function (entry, notifyPage) {
        // A foreign push/replace must remain a normal navigation step.
        if (this.pending || this.entry(window.history.state) !== entry) return;
        this.pending = entry;
        this.notifyPending = Boolean(notifyPage);
        try {
          window.history.back();
        } catch (error) {
          this.pending = null;
          this.flush();
        }
      },

      closed: function (drawer) {
        this.stack = this.stack.filter(function (item) { return item.drawer !== drawer; });
        if (this.stack.length || !this.current) return;
        var entry = this.current;
        entry.active = false;
        this.current = null;
        if (!this.handling) this.consume(entry);
      },

      flush: function () {
        if (this.pending) return;
        if (this.navigation) {
          var href = this.navigation;
          this.navigation = null;
          this.queued.clear();
          window.location.assign(href);
          return;
        }
        var ids = Array.from(this.queued);
        this.queued.clear();
        ids.forEach(function (id) { window.themeDrawer.open(id); });
      },

      pop: function (event) {
        var arrived = this.entry(event.state);
        var consumed = this.pending;
        var notifyPage = this.notifyPending;
        this.pending = null;
        this.notifyPending = false;
        // Dismissed entries can remain ahead of the page or behind a filter step.
        // Skip only our own entry, never an unknown history state.
        if (arrived && !arrived.active) {
          this.handling = true;
          this.stack.slice().reverse().forEach(function (item) { window.themeDrawer.close(item.id); });
          this.handling = false;
          event.stopImmediatePropagation();
          this.consume(arrived, !consumed || notifyPage);
          return;
        }
        if (consumed) {
          if (!notifyPage && window.location.href === consumed.url) event.stopImmediatePropagation();
          this.flush();
          return;
        }
        var entry = this.current;
        if (!entry || !this.stack.length) return;
        this.handling = true;
        if (window.location.href !== entry.url && arrived !== entry) {
          // A deliberate jump to another URL keeps its ordinary page/filter behavior.
          this.stack.slice().reverse().forEach(function (item) { window.themeDrawer.close(item.id); });
        } else {
          var top = overlayLayer.top();
          if (top && top.type === 'popup') top.close();
          else {
            var last = this.stack[this.stack.length - 1];
            window.themeDrawer.close(last.id);
          }
          if (arrived !== entry || this.stack.length === 0) event.stopImmediatePropagation();
        }
        this.handling = false;
        if (arrived === entry) {
          if (!this.stack.length) this.consume(entry, true);
        } else {
          entry.active = false;
          this.current = null;
          if (this.stack.length) this.push();
        }
        this.flush();
      },
    };

    window.addEventListener('popstate', function (event) { drawerHistory.pop(event); }, true);
    window.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      var link = event.target.closest('a[href]');
      var entry = drawerHistory.current;
      if (!link || !entry || drawerHistory.entry(window.history.state) !== entry || link.hasAttribute('download')
        || (link.target && link.target !== '_self') || !/^https?:$/.test(new URL(link.href).protocol)
        || link.href === window.location.href
        || !drawerHistory.stack.some(function (item) { return item.wrapper.contains(link); })) return;
      // Consume the overlay entry before following an ordinary same-tab link. Returning
      // from the destination then reaches the original page in one Back, including BFCache.
      event.preventDefault();
      drawerHistory.navigation = link.href;
      drawerHistory.handling = true;
      drawerHistory.stack.slice().reverse().forEach(function (item) { window.themeDrawer.close(item.id); });
      drawerHistory.handling = false;
      drawerHistory.consume(entry);
      drawerHistory.flush();
    });

    window.themeDrawer = {
      drawers: {},
      _scrollLocks: [],

      register: function (id, options) {
        var previous = this.drawers[id];
        if (previous) {
          this.close(id);
          if (previous.closeTimer) {
            clearTimeout(previous.closeTimer);
            this._unlockPageScroll(previous);
            previous.elements.wrapper.style.display = 'none';
          }
        }
        this.drawers[id] = {
          isOpen: false,
          options: options || {},
          zIndex: options && options.zIndex ? options.zIndex : null,
          previouslyFocused: null,
          closeTimer: null,
          openFrame: null,
        };
      },

      open: function (id) {
        var drawer = this.drawers[id];
        if (!drawer) {
          console.warn('Drawer not registered:', id);
          return;
        }
        // A pending Back must settle before a replacement drawer pushes a new entry.
        if (drawerHistory.pending) {
          drawerHistory.queued.add(id);
          return;
        }

        var wrapper = document.getElementById(id);
        var overlay = document.getElementById(id + '-overlay');
        var panel = document.getElementById(id + '-panel');

        if (!wrapper || !overlay || !panel) {
          console.warn('Drawer elements not found for:', id);
          return;
        }

        if (drawer.closeTimer) {
          clearTimeout(drawer.closeTimer);
          drawer.closeTimer = null;
        }

        if (drawer.isOpen) {
          wrapper.style.display = 'block';
          return;
        }

        drawer.elements = { wrapper: wrapper, overlay: overlay, panel: panel };
        drawer.isOpen = true;
        drawer.previouslyFocused = document.activeElement && document.activeElement !== document.body
          ? document.activeElement
          : null;

        // 应用 z-index（如果已动态设置）
        if (drawer.zIndex) {
          this._applyZIndex(wrapper, overlay, panel, drawer.zIndex);
        }

        overlay.classList.remove('theme-drawer-overlay-leave', 'theme-drawer-overlay-leave-start', 'theme-drawer-overlay-leave-end');
        panel.classList.remove('theme-drawer-panel-leave', 'theme-drawer-panel-leave-start', 'theme-drawer-panel-leave-end');
        // Set the off-screen start state while hidden, before scroll-lock reads can flush layout.
        overlay.classList.add('theme-drawer-overlay-enter', 'theme-drawer-overlay-enter-start');
        panel.classList.add('theme-drawer-panel-enter', 'theme-drawer-panel-enter-start');
        this._lockPageScroll(drawer, panel);
        wrapper.style.display = 'block';
        overlayLayer.open({
          id: 'drawer:' + id,
          type: 'drawer',
          element: panel,
          close: function () {
            window.themeDrawer.close(id);
          },
        });
        drawerHistory.track(id, drawer, wrapper);

        // 让浏览器提交初始帧后再启动 transition，不读取 offsetHeight 强制布局。
        // 焦点检查先于第二帧的样式写入；关闭时取消尚未完成的打开操作。
        var manager = this;
        drawer.openFrame = requestAnimationFrame(function () {
          drawer.openFrame = requestAnimationFrame(function () {
            drawer.openFrame = null;
            if (!drawer.isOpen || !wrapper.isConnected) return;
            var top = overlayLayer.top();
            if (top && top.id === 'drawer:' + id) manager._focusFirstElement(panel);
            overlay.classList.remove('theme-drawer-overlay-enter-start');
            overlay.classList.add('theme-drawer-overlay-enter-end');
            panel.classList.remove('theme-drawer-panel-enter-start');
            panel.classList.add('theme-drawer-panel-enter-end');
            wrapper.dispatchEvent(new CustomEvent('theme-drawer:opened', { detail: { id: id } }));
          });
        });
      },

      close: function (id) {
        drawerHistory.queued.delete(id);
        var drawer = this.drawers[id];
        if (!drawer || !drawer.isOpen) return;

        var wrapper = document.getElementById(id) || drawer.elements.wrapper;
        var overlay = document.getElementById(id + '-overlay') || drawer.elements.overlay;
        var panel = document.getElementById(id + '-panel') || drawer.elements.panel;

        if (!wrapper || !overlay || !panel) return;

        drawer.isOpen = false;
        drawerHistory.closed(drawer);
        if (drawer.openFrame !== null) {
          cancelAnimationFrame(drawer.openFrame);
          drawer.openFrame = null;
        }

        overlayLayer.close('drawer:' + id);
        // 已显示的面板可以直接从当前计算状态过渡到离场状态。
        overlay.classList.remove('theme-drawer-overlay-enter', 'theme-drawer-overlay-enter-start', 'theme-drawer-overlay-enter-end');
        overlay.classList.add('theme-drawer-overlay-leave', 'theme-drawer-overlay-leave-end');
        panel.classList.remove('theme-drawer-panel-enter', 'theme-drawer-panel-enter-start', 'theme-drawer-panel-enter-end');
        panel.classList.add('theme-drawer-panel-leave', 'theme-drawer-panel-leave-end');

        if (drawer.closeTimer) clearTimeout(drawer.closeTimer);
        drawer.closeTimer = setTimeout(function () {
          drawer.closeTimer = null;
          if (drawer.isOpen) return;
          wrapper.style.display = 'none';
          overlay.className = 'theme-drawer-overlay';
          panel.className = 'theme-drawer-panel theme-drawer-panel--' + (drawer.options.position || 'right');
          window.themeDrawer._unlockPageScroll(drawer);
          var top = overlayLayer.top();
          if (drawer.previouslyFocused && drawer.previouslyFocused.isConnected
            && drawer.previouslyFocused.getClientRects().length
            && (!top || top.element && top.element.contains(drawer.previouslyFocused))) {
            drawer.previouslyFocused.focus({ preventScroll: true });
          }
          drawer.previouslyFocused = null;
          wrapper.dispatchEvent(new CustomEvent('theme-drawer:closed', { detail: { id: id } }));
        }, 300);
      },

      toggle: function (id) {
        var drawer = this.drawers[id];
        if (!drawer) return;
        if (drawer.isOpen) {
          this.close(id);
        } else {
          this.open(id);
        }
      },

      isOpen: function (id) {
        var drawer = this.drawers[id];
        return drawer ? drawer.isOpen : false;
      },

      /**
       * 动态设置 drawer 的 z-index 层级
       * @param {string} id - drawer ID
       * @param {number} zIndex - 新的 z-index 值
       * @description 设置后会同时更新 wrapper、overlay 和 panel 的 z-index
       *              overlay 的 z-index 会自动设置为 zIndex - 1
       */
      setZIndex: function (id, zIndex) {
        var drawer = this.drawers[id];
        if (!drawer) {
          console.warn('Drawer not registered:', id);
          return;
        }

        var wrapper = document.getElementById(id);
        var overlay = document.getElementById(id + '-overlay');
        var panel = document.getElementById(id + '-panel');

        if (!wrapper || !overlay || !panel) {
          console.warn('Drawer elements not found for:', id);
          return;
        }

        drawer.zIndex = zIndex;
        this._applyZIndex(wrapper, overlay, panel, zIndex);

        // 更新 data 属性
        wrapper.setAttribute('data-z-index', zIndex);
      },

      /**
       * 获取 drawer 当前的 z-index
       * @param {string} id - drawer ID
       * @returns {number|null} - 当前 z-index 值
       */
      getZIndex: function (id) {
        var drawer = this.drawers[id];
        if (!drawer) return null;
        return drawer.zIndex || parseInt(drawer.options.zIndex) || null;
      },

      /**
       * 重置 drawer 的 z-index 到默认值
       * @param {string} id - drawer ID
       */
      resetZIndex: function (id) {
        var drawer = this.drawers[id];
        if (!drawer) return;

        var wrapper = document.getElementById(id);
        var overlay = document.getElementById(id + '-overlay');
        var panel = document.getElementById(id + '-panel');

        if (!wrapper || !overlay || !panel) return;

        drawer.zIndex = null;

        // 从 data 属性获取原始 z-index
        var originalZIndex = wrapper.getAttribute('data-z-index');
        if (originalZIndex) {
          this._applyZIndex(wrapper, overlay, panel, parseInt(originalZIndex));
        }
      },

      /**
       * 内部方法：应用 z-index 到元素
       * @private
       */
      _applyZIndex: function (wrapper, overlay, panel, zIndex) {
        var backdropZIndex = zIndex - 1;

        // 使用 CSS 变量设置 z-index
        wrapper.style.setProperty('--drawer-z-index', zIndex);
        overlay.style.setProperty('--drawer-backdrop-z-index', backdropZIndex);
        panel.style.setProperty('--drawer-panel-z-index', zIndex);
      },

      _focusableSelector: [
        'a[href]',
        'area[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'iframe',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex="-1"])',
      ].join(','),

      _getFocusableElements: function (panel) {
        return Array.prototype.slice.call(panel.querySelectorAll(this._focusableSelector)).filter(function (element) {
          return element.tabIndex >= 0 && !element.matches(':disabled')
            && !element.closest('[hidden], [inert], [aria-hidden="true"]')
            && element.getClientRects().length > 0
            && window.getComputedStyle(element).visibility === 'visible';
        });
      },

      _focusFirstElement: function (panel) {
        var candidates = panel.querySelectorAll(this._focusableSelector);
        for (var index = 0; index < candidates.length; index += 1) {
          var element = candidates[index];
          if (element.tabIndex >= 0 && !element.matches(':disabled')
            && !element.closest('[hidden], [inert], [aria-hidden="true"]')
            && element.getClientRects().length > 0
            && window.getComputedStyle(element).visibility === 'visible') {
            element.focus({ preventScroll: true });
            return;
          }
        }
        panel.focus({ preventScroll: true });
      },

      _trapFocus: function (event) {
        if (event.key !== 'Tab' || event.defaultPrevented) return;
        var top = overlayLayer.top();
        if (!top || top.type !== 'drawer') return;
        var panel = top.element;
        if (!panel) return;

        var focusable = this._getFocusableElements(panel);

        if (!focusable.length) {
          event.preventDefault();
          panel.focus({ preventScroll: true });
          return;
        }

        // Match popup keyboard behavior even when WebKit skips links in its native Tab order.
        event.preventDefault();
        var current = focusable.indexOf(document.activeElement);
        var next = current < 0
          ? (event.shiftKey ? focusable.length - 1 : 0)
          : (current + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
        focusable[next].focus({ preventScroll: true });
      },

      _closeTopmost: function () {
        var topmostId = null;
        var topmostZ = -1;
        for (var id in this.drawers) {
          if (!this.drawers.hasOwnProperty(id) || !this.drawers[id].isOpen) continue;
          var zIndex = this.drawers[id].zIndex || parseInt(this.drawers[id].options.zIndex, 10) || 0;
          if (zIndex >= topmostZ) {
            topmostId = id;
            topmostZ = zIndex;
          }
        }
        if (topmostId) this.close(topmostId);
      },

      _shouldLockPageScroll: function (drawer) {
        return drawer.options.lockPageScroll === true || drawer.options.lockBodyScroll === true || drawer.options.lockDocumentElementScroll === true;
      },

      _canScrollWithin: function (target, panel, delta, horizontal) {
        if (!panel.contains(target)) return false;
        for (var node = target instanceof Element ? target : target.parentElement; node; node = node.parentElement) {
          var style = window.getComputedStyle(node);
          var overflow = horizontal ? style.overflowX : style.overflowY;
          var position = horizontal ? node.scrollLeft : node.scrollTop;
          var extent = horizontal ? node.scrollWidth - node.clientWidth : node.scrollHeight - node.clientHeight;
          if (/(auto|scroll)/.test(overflow) && extent > 1 && (delta < 0 ? position > 0 : position < extent - 1)) return true;
          if (node === panel) break;
        }
        return false;
      },

      _lockPageScroll: function (drawer, panel) {
        if (!this._shouldLockPageScroll(drawer) || drawer.pageScrollLocked) return;

        drawer.previousDocumentOverflow = document.documentElement.style.overflow;
        drawer.previousScrollbarGutter = document.documentElement.style.scrollbarGutter;
        drawer.lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
        drawer.pageScrollLocked = true;
        this._scrollLocks.push(drawer);
        var manager = this;
        if (typeof drawer.options.preservePageScrollbar === 'string') {
          drawer.scrollbarMedia = window.matchMedia(drawer.options.preservePageScrollbar);
          drawer.scrollbarMediaChange = function () { manager._applyPageScrollLock(drawer); };
          drawer.scrollbarMedia.addEventListener('change', drawer.scrollbarMediaChange);
          drawer.scrollGuard = new AbortController();
          var touch = null;
          var active = function () {
            var top = overlayLayer.top();
            return drawer.scrollbarMedia.matches && (!top || top.element === panel);
          };
          var contain = function (event, deltaX, deltaY) {
            if (!active() || event.defaultPrevented || event.ctrlKey) return;
            if (!manager._canScrollWithin(event.target, panel, Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY, Math.abs(deltaX) > Math.abs(deltaY))) event.preventDefault();
          };
          document.addEventListener('wheel', function (event) {
            contain(event, event.deltaX, event.deltaY);
          }, { passive: false, signal: drawer.scrollGuard.signal });
          document.addEventListener('touchstart', function (event) {
            touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
          }, { passive: true, signal: drawer.scrollGuard.signal });
          document.addEventListener('touchmove', function (event) {
            if (!touch || event.touches.length !== 1) return;
            var point = event.touches[0];
            var deltaX = touch.x - point.clientX;
            var deltaY = touch.y - point.clientY;
            touch = { x: point.clientX, y: point.clientY };
            // Horizontal carousels handle transformed slides rather than native overflow.
            if (Math.abs(deltaX) > Math.abs(deltaY) && panel.contains(event.target)) return;
            contain(event, deltaX, deltaY);
          }, { passive: false, signal: drawer.scrollGuard.signal });
          document.addEventListener('keydown', function (event) {
            if (!active() || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
            if (event.target.closest('input, textarea, select, [contenteditable="true"], video, audio')) return;
            if (event.key === ' ' && event.target.closest('button, [role="button"]')) return;
            var directions = { ArrowUp: -1, ArrowDown: 1, PageUp: -1, PageDown: 1, Home: -1, End: 1, ' ': event.shiftKey ? -1 : 1 };
            if (directions[event.key]) contain(event, 0, directions[event.key]);
          }, { signal: drawer.scrollGuard.signal });
        }
        this._applyPageScrollLock(drawer);
      },

      _applyPageScrollLock: function (drawer) {
        if (drawer.scrollbarMedia && drawer.scrollbarMedia.matches) {
          if (drawer.pageOverflowHidden) {
            document.documentElement.style.overflow = drawer.previousDocumentOverflow || '';
            document.documentElement.style.scrollbarGutter = drawer.previousScrollbarGutter || '';
            drawer.pageOverflowHidden = false;
          }
          return;
        }
        // Keep the document in flow: fixing body resets scrollY and moves sticky product media.
        // Overlay scrollbars need no reserved gutter; classic scrollbars must retain their width.
        if (window.innerWidth > document.documentElement.clientWidth) {
          document.documentElement.style.scrollbarGutter = 'stable';
        }
        document.documentElement.style.overflow = 'hidden';
        drawer.pageOverflowHidden = true;
      },

      _unlockPageScroll: function (drawer) {
        if (!drawer.pageScrollLocked) return;

        var index = this._scrollLocks.indexOf(drawer);
        var next = this._scrollLocks[index + 1];
        if (next) {
          // Closing a lower layer transfers its original page state to the next lock.
          next.previousDocumentOverflow = drawer.previousDocumentOverflow;
          next.previousScrollbarGutter = drawer.previousScrollbarGutter;
          next.lockedScrollY = drawer.lockedScrollY;
        }
        if (index >= 0) this._scrollLocks.splice(index, 1);
        if (drawer.pageOverflowHidden && !next) {
          document.documentElement.style.overflow = drawer.previousDocumentOverflow || '';
          document.documentElement.style.scrollbarGutter = drawer.previousScrollbarGutter || '';
          if (window.scrollY !== drawer.lockedScrollY) window.scrollTo(0, drawer.lockedScrollY || 0);
        }
        if (drawer.scrollbarMedia) drawer.scrollbarMedia.removeEventListener('change', drawer.scrollbarMediaChange);
        if (drawer.scrollGuard) drawer.scrollGuard.abort();
        drawer.scrollbarMedia = null;
        drawer.scrollGuard = null;
        drawer.scrollbarMediaChange = null;
        drawer.pageOverflowHidden = false;
        drawer.pageScrollLocked = false;
        drawer.previousDocumentOverflow = null;
        drawer.previousScrollbarGutter = null;
        drawer.lockedScrollY = null;
      },

      /**
       * 获取所有已注册 drawer 的层级信息
       * @returns {Array} - drawer 层级信息数组
       */
      getLayersInfo: function () {
        var info = [];
        for (var id in this.drawers) {
          if (this.drawers.hasOwnProperty(id)) {
            var drawer = this.drawers[id];
            info.push({
              id: id,
              isOpen: drawer.isOpen,
              zIndex: drawer.zIndex || drawer.options.zIndex || 'default',
              priority: drawer.options.priority || 'default',
            });
          }
        }
        return info.sort(function (a, b) {
          return (b.zIndex || 0) - (a.zIndex || 0);
        });
      },
    };

    document.addEventListener('keydown', function (event) {
      window.themeDrawer._trapFocus(event);
    });
    document.addEventListener('focusin', function (event) {
      var top = overlayLayer.top();
      if (top && top.type === 'drawer' && top.element && !top.element.contains(event.target)) {
        window.themeDrawer._focusFirstElement(top.element);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
